import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Link } from "react-router-dom";
import { classifierColumns } from "src/business/classifier";
import { MdmTable } from "src/components/MdmTable";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ObjectsManager } from "../ObjectsManager";
import { ManagementClassifiersActions } from "./ManagementClassifiersActions";
import { managementClassifiersStore as pageStore } from "./ManagementClassifiersStore";

export const ManagementClassifiers: React.FC = observer(() => {
  const { tableStore } = pageStore;

  const tools = (
    <>
      <ManagementClassifiersActions />
      <RtColumnsSettingsButton store={tableStore} />
      <Link to={makeUrl(PageUrl.managementClassifierCard, { id: "new" })}>
        <Button type="primary" icon={<PlusCircleOutlined />}>
          Создать
        </Button>
      </Link>
    </>
  );

  return (
    <ObjectsManager tab="classifiers">
      <ToolBox2 extraTools={tools} paddingMode="page">
        <MdmTable
          store={tableStore}
          columns={classifierColumns}
          rowClick={{
            type: "link",
            builder: (row) =>
              makeUrl(PageUrl.managementClassifierCard, { id: row.id }),
          }}
          resizableColumns
        />
      </ToolBox2>
    </ObjectsManager>
  );
});
